"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftCandidateDto = instanceOfShiftCandidateDto;
exports.ShiftCandidateDtoFromJSON = ShiftCandidateDtoFromJSON;
exports.ShiftCandidateDtoFromJSONTyped = ShiftCandidateDtoFromJSONTyped;
exports.ShiftCandidateDtoToJSON = ShiftCandidateDtoToJSON;
exports.ShiftCandidateDtoToJSONTyped = ShiftCandidateDtoToJSONTyped;
const State_1 = require("./State");
/**
 * Check if a given object implements the ShiftCandidateDto interface.
 */
function instanceOfShiftCandidateDto(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    return true;
}
function ShiftCandidateDtoFromJSON(json) {
    return ShiftCandidateDtoFromJSONTyped(json, false);
}
function ShiftCandidateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'specialtyCode': json['specialtyCode'] == null ? undefined : json['specialtyCode'],
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'facilityId': json['facilityId'],
        'state': json['state'] == null ? undefined : (0, State_1.StateFromJSON)(json['state']),
    };
}
function ShiftCandidateDtoToJSON(json) {
    return ShiftCandidateDtoToJSONTyped(json, false);
}
function ShiftCandidateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'specialtyCode': value['specialtyCode'],
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'facilityId': value['facilityId'],
        'state': (0, State_1.StateToJSON)(value['state']),
    };
}
//# sourceMappingURL=ShiftCandidateDto.js.map